<template>
  <div :class="['send', { 'is-loading': loading }]">
    <el-input
      type="textarea"
      v-model="inputMessage"
      :rows="2"
      placeholder="请输入你要写的内容..."
      resize="none"
      class="chat-input"
      @keyup.enter.native="sendUserMessage"
    ></el-input>
    <div class="tags-list">
      <el-checkbox
        v-model="questionParams.deep_seek"
        label="深度思考"
        border
        class="no-inner"
      >
        <div class="switch">
          <img src="../assets/deep.png" alt="" width="14px" />&nbsp; 深度思考
        </div>
      </el-checkbox>
      <el-checkbox
        v-model="questionParams.enable_search"
        label="联网搜索"
        border
        class="no-inner"
      >
        <div class="switch">
          <img src="../assets/online-search.png" alt="" width="14px" />&nbsp; 联网搜索
        </div>
      </el-checkbox>
      <div
        class="el-radio-group tags"
        role="radiogroup"
        @keydown="handleRadioKeydown"
      >
        <label
          v-for="item in tagList"
          :key="item.id"
          class="el-radio is-bordered radio"
          :class="{ 'is-checked': selectedTags === item.knowledgeCode }"
          role="radio"
          :aria-checked="selectedTags === item.knowledgeCode"
          :tabindex="selectedTags === item.knowledgeCode ? 0 : -1"
          @click="selectedTags = item.knowledgeCode"
          @keydown.space.prevent="selectedTags = item.knowledgeCode"
        >
          <span
            class="el-radio__input"
            :class="{ 'is-checked': selectedTags === item.knowledgeCode }"
          >
            <span class="el-radio__inner"></span>
          </span>
          <span class="el-radio__label">{{ item.knowledgeName }}</span>
        </label>
      </div>
    </div>
    <button
      v-if="loading"
      type="button"
      class="stop-btn"
      aria-label="停止回答"
      title="停止回答"
      @click="$emit('stop')"
    >
      <span class="stop-btn__square" aria-hidden="true"></span>
    </button>
    <img
      src="../assets/send.png"
      alt=""
      :class="['send-btn', loading && 'disabled']"
      @click="sendUserMessage"
    />
  </div>
</template>

<script>
import { knowledgeLibrary, getModelConfig } from '@/api';

export default {
  name: "MessageInput",
  props: {
    isLogin: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      inputMessage: "",
      selectedTags: "",
      tagList: [],
      questionParams: {
        modelKey: 'doubao',
        max_token: 5120,
        temperature: 0.7,
        deep_seek: true,
        enable_search: true,
        stream: true,
        history: [],
        question: '',
        topic_ids: ['gJVQXlD0'],
        refs: false,
      },
    };
  },
  mounted() {
    if (this.isLogin) {
      this.getLibrary();
    }
  },
  watch: {
    isLogin(newVal) {
      if (newVal) {
        this.getLibrary();
      }
    },
  },
  methods: {
    getDefaultModelConfig() {
      getModelConfig().then((response) => {
        const modelConfig = response.data;
        this.questionParams.modelKey = modelConfig.modelKey || this.questionParams.modelKey;
        this.questionParams.deep_seek = modelConfig.enableThinking || this.questionParams.deep_seek;
        this.questionParams.enable_search = modelConfig.enableSearch || this.questionParams.enable_search;
        this.questionParams.max_token = modelConfig.maxTokens || this.questionParams.max_token;
        this.questionParams.temperature = modelConfig.temperature || this.questionParams.temperature;
        this.selectedTags = modelConfig.knowledgeIds || this.questionParams.topic_ids[0];
      });
    },

    getLibrary() {
      knowledgeLibrary()
        .then(({ rows }) => {
          rows = rows.map((item) => {
            item.knowledgeName = item.knowledgeName.replace("洞界", "热点").replace("热点风向标", "摩投投资库");
            if (["eYxPPqLY"].includes(item.knowledgeCode)) return null;
            return item;
          }).filter((item) => item != null);
          this.tagList = rows;
          this.selectedTags = rows[0]?.knowledgeCode;
          this.getDefaultModelConfig();
        })
        .catch(() => {});
    },

    handleRadioKeydown(e) {
      const target = e.target;
      if (target.getAttribute('role') !== 'radio') return;
      const radios = this.$el.querySelectorAll('.tags [role=radio]');
      const index = Array.prototype.indexOf.call(radios, target);
      const length = radios.length;
      if (length <= 1) return;
      let nextIndex = -1;
      switch (e.keyCode) {
        case 37:
        case 38:
          e.preventDefault();
          e.stopPropagation();
          nextIndex = index === 0 ? length - 1 : index - 1;
          break;
        case 39:
        case 40:
          e.preventDefault();
          e.stopPropagation();
          nextIndex = index === length - 1 ? 0 : index + 1;
          break;
        default:
          return;
      }
      const nextItem = this.tagList[nextIndex];
      if (!nextItem) return;
      this.selectedTags = nextItem.knowledgeCode;
      this.$nextTick(() => radios[nextIndex].focus());
    },

    sendUserMessage() {
      if (!this.isLogin) {
        this.$emit("openLogin");
        return;
      }
      if (this.loading) return;
      if (!this.selectedTags) {
        this.$message.warning('请选择类型');
        return;
      }
      if (this.inputMessage.trim()) {
        this.$emit("send", {
          message: this.inputMessage,
          tags: this.selectedTags,
          params: { ...this.questionParams },
        });
        this.inputMessage = "";
      }
    },

    getSelectedTags() {
      return this.selectedTags;
    },

    setInputMessage(message) {
      this.inputMessage = message;
    },
  },
};
</script>

<style scoped lang="scss">
.send {
  width: 80%;
  margin: 0 auto;
  position: absolute;
  bottom: 60px;
  left: 10%;
  border-radius: 20px;
  border: 1px solid #ffb061;
  overflow: hidden;
  padding-top: 10px;
  padding-bottom: 17px;
  background: #fff;
  min-width: 0;

  .tags-list {
    display: flex;
    padding-right: 40px;
    margin-left: 20px;

    .tags {
      margin: 0 10px;
      min-width: 0;
    }

    .radio {
      margin-right: 0;
    }
  }

  &-btn {
    width: 39px;
    height: 39px;
    position: absolute;
    right: 18px;
    bottom: 17px;
    cursor: pointer;

    &.disabled {
      filter: grayscale(100%);
      -webkit-filter: grayscale(100%);
    }
  }

  .stop-btn {
    width: 36px;
    height: 36px;
    position: absolute;
    right: 66px;
    bottom: 18px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: none;
    border-radius: 50%;
    background: linear-gradient(309deg, #ffc258 0%, #f4a113 100%);
    box-shadow: 0 4px 12px rgba(244, 161, 19, 0.34);
    cursor: pointer;
    transition: filter 0.2s ease, box-shadow 0.2s ease, transform 0.15s ease;

    &:hover {
      filter: brightness(1.05);
      box-shadow: 0 5px 15px rgba(244, 161, 19, 0.44);
    }

    &:active {
      transform: scale(0.96);
    }

    &__square {
      width: 12px;
      height: 12px;
      border-radius: 3px;
      background: #fff;
      display: block;
    }
  }

  &.is-loading {
    .tags-list {
      padding-right: 88px;
    }
  }
}

.switch {
  display: flex;
  align-items: center;
}

@media (max-width: 768px) {
  .send {
    width: calc(100% - 24px);
    left: 12px;
    bottom: 72px;
    margin: 0;
    padding: 8px 10px 12px;
    border-radius: 14px;

    ::v-deep .el-textarea__inner {
      min-height: 48px !important;
      padding: 6px 8px;
      font-size: 14px;
      line-height: 20px;
    }

    .tags-list {
      flex-wrap: wrap;
      align-items: center;
      gap: 8px;
      margin-top: 8px;
      margin-left: 0;
      padding-right: 42px;

      .tags {
        display: flex;
        flex: 1 1 100%;
        gap: 8px;
        margin: 0;
        overflow-x: auto;
        padding-bottom: 2px;
        -webkit-overflow-scrolling: touch;
      }

      .radio {
        flex: 0 0 auto;
      }
    }

    &-btn {
      width: 34px;
      height: 34px;
      right: 12px;
      bottom: 12px;
    }

    .stop-btn {
      width: 32px;
      height: 32px;
      right: 52px;
      bottom: 13px;

      &__square {
        width: 10px;
        height: 10px;
        border-radius: 2px;
      }
    }

    &.is-loading {
      .tags-list {
        padding-right: 82px;
      }
    }
  }

  .switch {
    white-space: nowrap;
    font-size: 12px;
  }
}
</style>
